import { useLang } from "@/i18n/LangContext";

export function LangToggle() {
  const { lang, toggleLang } = useLang();
  return (
    <button
      onClick={toggleLang}
      className="fixed bottom-5 right-5 z-50 flex items-center gap-1.5 bg-neutral-900/90 backdrop-blur-sm border border-purple-500/30 hover:border-purple-500/60 text-xs font-bold tracking-wider px-3.5 py-2.5 rounded-full shadow-[0_0_15px_rgba(192,38,211,0.15)] hover:shadow-[0_0_25px_rgba(192,38,211,0.3)] transition-all duration-300 select-none"
      data-testid="lang-toggle"
      title={lang === "en" ? "Schimba in Romana" : "Switch to English"}
    >
      <span className={lang === "en" ? "text-purple-400" : "text-neutral-500"}>EN</span>
      <span className="text-neutral-600">/</span>
      <span className={lang === "ro" ? "text-purple-400" : "text-neutral-500"}>RO</span>
    </button>
  );
}
